




































import { Component, Mixins } from 'vue-property-decorator';
import OverviewMixin from '@/mixins/OverviewMixin';
import FieldDefs from './FieldDefs';
import SendEmailDialog from '@/components/SendEmailDialog.vue';
import ConfirmDialog from '@/components/ConfirmDialog.vue';
import { OverviewLayoutITF } from '@/interfaces';
import {commitAddNotification} from '@/store/main/mutations';
import {new_curdate} from '@/claesutils';
function check_bool(v): boolean {
  // console.log('check_bool', v, typeof(v));
  if (v === true) {
    return true;
  } else if (v === 'true') {
    return true;
  }
  return false;
}

interface MarkPaidRec {
  bank_date: string;
  account_nr: string|null;
}

@Component({
  components: {
    SendEmailDialog,
    ConfirmDialog
  }
})
export default class SalesOverview extends Mixins(OverviewMixin) {
  public tableCfg = FieldDefs;
  public apiUrl = this.getTableCfg(this.tableCfg, 'apiUrl');
  public showEmailOverdue = false;
  public showSendAccounting = false;
  public showMarkPaid = false;
  public showDeleteInvoices = false;
  public dialogMarkPaid = false;

  public recMarkPaid: MarkPaidRec = {bank_date: '', account_nr: null};

  public handleTableLoaded(overview) {
    this.showEmailOverdue = check_bool(overview.filters.overdue) && (overview.filters.customer_id > 0) && (overview.tableTotal > 0);
    this.showSendAccounting = check_bool(overview.filters.not_sent_accounting) && (overview.filters.customer_id > 0) && (overview.tableTotal > 0);
    // console.log(check_bool(overview.filters.not_sent_accounting) , (overview.filters.customer_id > 0) , (overview.tableTotal > 0));
  }

  public handleItemSelected(overview, event) {
    // console.log('handleItemSelected', event, overview.multiSelect, overview.countSelections(), overview.countSelections() + (event.value ? 1 : -1));
    this.changeSelection(overview.countSelections() + (event.value ? 1 : -1));
  }

  public handleToggleSelectAll(overview, event) {
    // console.log('handleToggleSelectAll', event, overview.multiSelect, overview.countSelections(), event.value ? event.items.length : 0);
    this.changeSelection(event.value ? event.items.length : 0);
  }
  public handleChangeMultiSelect(overview, event) {
    // console.log('handleChangeMultiSelect', event, overview.multiSelect, overview.countSelections());
    this.changeSelection(event.value ? overview.countSelections() : 0);
  }
  public changeSelection(count) {
    // console.log('changeSelection', count);
    this.showDeleteInvoices = this.showMarkPaid = count > 0;

  }



  public startSendOverDueEmail() {
    const overview: any = this.$refs.overview;
    const dialog: any = this.$refs.emaildialog;
    dialog.startDialog(0, null, 'getoverduemailtemplate', 'sendoverduemail', {customer_id: overview.filters.customer_id});
  }

  public startMarkPaid() {
    const overview: any = this.$refs.overview;
    this.recMarkPaid.bank_date = new_curdate();
    this.dialogMarkPaid = true;
  }

  public async executeMarkPaid(formrec) {
    const overview: any = this.$refs.overview;
    const form: any = this.$refs.formMarkPaid;
    if (form.validate()) {
      this.dialogMarkPaid = false;
      const rec = {...formrec};
      rec.idlist = overview.getSelectedIds();
      // console.log('executeMarkPaid', rec);
      const response = await this.api.postAction(this.$store, this.getTableCfg(this.tableCfg, 'apiUrl') + 'markpaid', rec);
      overview.tableUpdateData(true);
    }
  }

  public async executeDeleteInvoices() {
    const overview: any = this.$refs.overview;
    const rec = {idlist: overview.getSelectedIds()};
    const response = await this.api.postAction(this.$store, this.getTableCfg(this.tableCfg, 'apiUrl') + 'deleteinvoices', rec);
    overview.tableUpdateData(true);
  }


  public async sendAccounting() {
    const response = await this.api.postAction(this.$store, this.getTableCfg(this.tableCfg, 'apiUrl') + 'sendaccounting', {filter: this.getFilterValues()});
    if (response) {
      const data: any = response.data;
      // console.log(data);
      const msg = `${data.mails_sent} facturen verstuurd.`;
      commitAddNotification(this.$store, {content: msg, color: 'success'});
      if (this.$refs.overview) {
        ((this.$refs.overview as unknown) as OverviewLayoutITF).tableUpdateData(true);
      }
    }
  }
}
